<template>
  <div>
    <!-- Analytic component -->
    <b-card
      v-if="modeCreate && dataMaster.name.toLowerCase() === 'analytic'">
      <j-analytic-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Analytic2 component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'analytic_v2'">
      <j-analytic2-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Board component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'board'">
      <j-board-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Channel component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'channel'">
      <j-channel-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Digital signature component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'digital_signature'">
      <j-digital-signature-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Digital signature requester component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name === 'digital_signature_workflow_requester'">
      <j-digital-signature-req-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Digital signature approver component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name === 'digital_signature_workflow_approver'">
      <j-digital-signature-app-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Discussion component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'discussion'">
      <j-discussion-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Form component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'form'">
      <j-form-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Form UI component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'form_ui'">
      <j-form-ui-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Form UI component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'multiple_form_ui'">
      <j-multiple-form-ui-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Canvas component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'canvas'">
      <j-canvas-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Formula component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'formula'">
      <j-formula-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Hierarchy component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'hierarchy'">
      <j-hierarchy-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Custom Hierarchy component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'custom_hierarchy'">
      <j-custom-hierarchy-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- HTML component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'html'">
      <j-html-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Widget component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'widget'">
      <j-widget-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Workflow requestor component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'workflow'">
      <j-workflow-req-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Workflow approver component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'workflow_approver'">
      <j-workflow-app-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- CORE -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'cost_center'">
      <j-cost-center-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'employee_setup'">
      <j-employee-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'employee_grade_setup'">
      <j-grade-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'position_setup'">
      <j-position-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'flow_setup'">
      <j-flow-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'location_setup'">
      <j-location-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'orgunit_setup'">
      <j-org-unit-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'payroll_area'">
      <j-payroll-area-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'tax_location'">
      <j-tax-location-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- PAYROLL -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'basic_payroll_config'">
      <j-basic-payroll-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'company_payroll_config'">
      <j-company-payroll-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'component_payroll_config'">
      <j-component-payroll-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'employee_payslip'">
      <j-employee-payslip-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'personal_payslip'">
      <j-personal-payslip-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'run_payroll'">
      <j-run-payroll-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- TIMES -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'attendance_config'">
      <j-attendance-config-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'attendance_monitor'">
      <j-attendance-monitor-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'attendance_my_log'">
      <j-attendance-my-log-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'attendance_report'">
      <j-attendance-report-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'co_attendance_approver'">
      <j-co-attendance-approver-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'co_attendance_monitor'">
      <j-co-attendance-monitor-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'co_attendance_requestor'">
      <j-co-attendance-requestor-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'leave_approver'">
      <j-leave-approver-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'leave_config'">
      <j-leave-config-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'leave_monitor'">
      <j-leave-monitor-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'leave_requestor'">
      <j-leave-requestor-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'leave_report'">
      <j-leave-report-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Digital Signature component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name === 'digital_signature'">
      <j-digital-signature-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Digital Document component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name === 'digital_document'">
      <j-digital-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Embed url component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'embed_url'">
      <j-embed-url-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- TIMESHEET -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'timesheet'">
      <j-timesheet-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'timesheet_approval'">
      <j-timesheet-approval-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'timesheet_config'">
      <j-timesheet-config-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'timesheet_report'">
      <j-timesheet-report-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- BAKTI -->
    <!-- Bakti table component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'advanced_form_table'">
      <j-bakti-table-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Bakti workflow requestor component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'dynamic_workflow'">
      <j-bakti-workflow-req-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Bakti workflow approver component -->
    <b-card
      v-else-if="modeCreate && dataMaster.name.toLowerCase() === 'dynamic_workflow_approver'">
      <j-bakti-workflow-app-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>

    <!-- Default Setup Component -->
    <b-card
      v-else-if="modeCreate && dataMaster">
      <j-default-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeModal"
      />
    </b-card>
  </div>
</template>

<script>
import jAnalyticSetup from '@/views/pages/pages-component/jAnalyticSetup';
import jAnalytic2Setup from '@/views/pages/pages-component/jAnalytic2Setup';
import jBoardSetup from '@/views/pages/pages-component/jBoardSetup';
import jChannelSetup from '@/views/pages/pages-component/jChannelSetup';
import jDiscussionSetup from '@/views/pages/pages-component/jDiscussionSetup';
import jFormSetup from '@/views/pages/pages-component/jFormSetup';
import jFormUiSetup from '@/views/pages/pages-component/jFormUiSetup';
import jMultipleFormUiSetup from '@/views/pages/pages-component/jMultipleFormUiSetup';
import jCanvasSetup from '@/views/pages/pages-component/jCanvasSetup';
import jFormulaSetup from '@/views/pages/pages-component/jFormulaSetup';
import jHierarchySetup from '@/views/pages/pages-component/jHierarchySetup';
import jCustomHierarchySetup from '@/views/pages/pages-component/jCustomHierarchySetup';
import jWidgetSetup from '@/views/pages/pages-component/jWidgetSetup';
import jWorkflowReqSetup from '@/views/pages/pages-component/jWorkflowReqSetup';
import jWorkflowAppSetup from '@/views/pages/pages-component/jWorkflowAppSetup';
import jHtmlSetup from '@/views/pages/pages-component/jHtmlSetup';
import jDigitalSignatureSetup from '@/views/pages/pages-component/jDigitalSignatureSetup';
import jDigitalSignatureReqSetup from '@/views/pages/pages-component/jDigitalSignatureReqSetup';
import jDigitalSignatureAppSetup from '@/views/pages/pages-component/jDigitalSignatureAppSetup';
import jDigitalDocumentSetup from '@/views/pages/pages-component/jDigitalDocumentSetup';
import jEmbedUrlSetup from '@/views/pages/pages-component/jEmbedUrlSetup';

// CORE
import jCostCenterSetup from '@/views/pages/pages-component/core/jCostCenterSetup';
import jEmployeeSetup from '@/views/pages/pages-component/core/jEmployeeSetup';
import jFlowSetup from '@/views/pages/pages-component/core/jFlowSetup';
import jGradeSetup from '@/views/pages/pages-component/core/jGradeSetup';
import jLocationSetup from '@/views/pages/pages-component/core/jLocationSetup';
import jPositionSetup from '@/views/pages/pages-component/core/jPositionSetup';
import jOrgUnitSetup from '@/views/pages/pages-component/core/jOrgUnitSetup';
import jPayrollAreaSetup from '@/views/pages/pages-component/core/jPayrollAreaSetup';
import jTaxLocationSetup from '@/views/pages/pages-component/core/jTaxLocationSetup';

// PAYROLL COMPONENT
import jBasicPayrollSetup from '@/views/pages/pages-component/payroll/jBasicPayrollSetup';
import jCompanyPayrollSetup from '@/views/pages/pages-component/payroll/jCompanyPayrollSetup';
import jComponentPayrollSetup from '@/views/pages/pages-component/payroll/jComponentPayrollSetup';
import jEmployeePayslipSetup from '@/views/pages/pages-component/payroll/jEmployeePayslipSetup';
import jPersonalPayslipSetup from '@/views/pages/pages-component/payroll/jPersonalPayslipSetup';
import jRunPayrollSetup from '@/views/pages/pages-component/payroll/jRunPayrollSetup';

// TIMES COMPONENT
import jAttendanceConfigSetup from '@/views/pages/pages-component/times/jAttendanceConfigSetup';
import jAttendanceMonitorSetup from '@/views/pages/pages-component/times/jAttendanceMonitorSetup';
import jAttendanceMyLogSetup from '@/views/pages/pages-component/times/jAttendanceMyLogSetup';
import jAttendanceReportSetup from '@/views/pages/pages-component/times/jAttendanceReportSetup';
import jCoAttendanceApproverSetup from '@/views/pages/pages-component/times/jCoAttendanceApproverSetup';
import jCoAttendanceMonitorSetup from '@/views/pages/pages-component/times/jCoAttendanceMonitorSetup';
import jCoAttendanceRequestorSetup from '@/views/pages/pages-component/times/jCoAttendanceRequestorSetup';
import jLeaveApproverSetup from '@/views/pages/pages-component/times/jLeaveApproverSetup';
import jLeaveConfigSetup from '@/views/pages/pages-component/times/jLeaveConfigSetup';
import jLeaveMonitorSetup from '@/views/pages/pages-component/times/jLeaveMonitorSetup';
import jLeaveRequestorSetup from '@/views/pages/pages-component/times/jLeaveRequestorSetup';
import jLeaveReportSetup from '@/views/pages/pages-component/times/jLeaveReportSetup';
import jTimesheetSetup from '@/views/pages/pages-component/times/jTimesheetSetup';
import jTimesheetApprovalSetup from '@/views/pages/pages-component/times/jTimesheetApprovalSetup';
import jTimesheetConfigSetup from '@/views/pages/pages-component/times/jTimesheetConfigSetup';
import jTimesheetReportSetup from '@/views/pages/pages-component/times/jTimesheetReportSetup';

// BAKTI COMPONENT
import jBaktiTableSetup from '@/views/pages/pages-component/jBaktiTableSetup';
import jBaktiWorkflowAppSetup from '@/views/pages/pages-component/jBaktiWorkflowAppSetup';
import jBaktiWorkflowReqSetup from '@/views/pages/pages-component/jBaktiWorkflowReqSetup';

import jDefaultSetup from '@/views/pages/pages-component/jDefaultSetup';

// OTHERS
// import jPagesPrivilege from '@/views/pages/jPagesPrivilege';

export default {
  components: {
    jAnalyticSetup,
    jAnalytic2Setup,
    jBoardSetup,
    jChannelSetup,
    jDiscussionSetup,
    jFormSetup,
    jFormUiSetup,
    jMultipleFormUiSetup,
    jCanvasSetup,
    jFormulaSetup,
    jHierarchySetup,
    jCustomHierarchySetup,
    jWidgetSetup,
    jWorkflowAppSetup,
    jWorkflowReqSetup,
    jHtmlSetup,
    jDigitalSignatureSetup,
    jDigitalSignatureReqSetup,
    jDigitalSignatureAppSetup,
    jDigitalDocumentSetup,
    jEmbedUrlSetup,

    // CORE
    jCostCenterSetup,
    jEmployeeSetup,
    jFlowSetup,
    jGradeSetup,
    jLocationSetup,
    jPositionSetup,
    jOrgUnitSetup,
    jPayrollAreaSetup,
    jTaxLocationSetup,

    // Payroll
    jBasicPayrollSetup,
    jCompanyPayrollSetup,
    jComponentPayrollSetup,
    jEmployeePayslipSetup,
    jPersonalPayslipSetup,
    jRunPayrollSetup,

    // Times
    jAttendanceConfigSetup,
    jAttendanceMonitorSetup,
    jAttendanceMyLogSetup,
    jAttendanceReportSetup,
    jCoAttendanceApproverSetup,
    jCoAttendanceMonitorSetup,
    jCoAttendanceRequestorSetup,
    jLeaveApproverSetup,
    jLeaveConfigSetup,
    jLeaveMonitorSetup,
    jLeaveRequestorSetup,
    jLeaveReportSetup,
    jTimesheetSetup,
    jTimesheetApprovalSetup,
    jTimesheetConfigSetup,
    jTimesheetReportSetup,

    // Bakti
    jBaktiTableSetup,
    jBaktiWorkflowReqSetup,
    jBaktiWorkflowAppSetup,

    // others
    // jPagesPrivilege,
    jDefaultSetup,
  },

  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: () => false,
    },
    modeEdit: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/jPagesFormSetup.vue